jQuery(document).ready(function($) {
  $(document).on("click", ".notice-close", function(e) {
    $(this)
      .parent()
      .animate(
        {
          opacity: 0,
        },
        400,
        () => {
          $(this)
            .parent()
            .remove();
        }
      );
  });
});
